import { apiPath } from "@/api/api-path"
import api from "./service"

// Get Auto Backup Config List
export async function getSettings(key) {
  return api
    .get(apiPath.getSettings + key, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateSettings(data) {
  return api
    .put(apiPath.updateSettings + "allSettings", data, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

// Update Default Incident Information (In Global Settings)
export async function updateTicketIncidentDefaultInfo(data) {
  return api
    .put(apiPath.updateSettings + "ticketIncidentDefaultInfo", data, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

// Get Backup Config Monitoring
export async function getMonitoring() {
  return api
    .get(apiPath.getMonitoring, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}
